import { Checkbox } from '../../../../../../../../components/checkbox/checkbox';
import { useLang } from '../../../../../../../../hooks/use-lang';
import { useDishStore } from '../../../../../../../../store/use-dish-store';
import s from './menu-informer-create-dish-modal-step-4.module.css';

export const MenuInformerCreateDishModalStep4 = () => {
  const { t } = useLang();
  const { dish, handleUpdateDish } = useDishStore();

  return (
    <div className={s.feature}>
      <Checkbox
        checked={dish?.is_on}
        onClick={() => handleUpdateDish({ is_on: !dish?.is_on })}
        label={t('Блюдо активно')}
        data-testid="is-on-checkbox"
      />
    </div>
  );
};
